import { useNavigate } from 'react-router-dom'
import { Vars } from '@carrent/ui'

/**
 * Гаджет: соблюдение регламента.
 *
 * Одна цифра, за которой закреплена ответственность. Календарь и
 * напоминания отвечают «что чинить», этот — «в порядке ли парк».
 * Пустой срок считается нарушением наравне с просроченным: машина
 * без данных о страховке ничем не лучше машины с истёкшей.
 */
function tone(pct) {
  if (pct >= 95) return 'good'
  if (pct >= 80) return 'warn'
  return 'bad'
}

export function PmComplianceWidget({ data }) {
  const navigate = useNavigate()

  if (!data.total) {
    return <p className="widget-empty">В парке нет машин</p>
  }

  return (
    <div className="pm">
      <div className="pm__head">
        <span className={`pm__pct pm__pct--${tone(data.pct)}`}>{data.pct}%</span>
        <span className="pm__caption">
          {data.compliant} из {data.total} машин без просроченных сроков
        </span>
      </div>

      <span className="pm__track">
        <Vars
          as="span"
          className={`pm__bar pm__bar--${tone(data.pct)}`}
          vars={{ '--bar-w': `${data.pct}%` }}
        />
      </span>

      {data.breakdown.length > 0 && (
        <ul className="pm__breakdown">
          {data.breakdown.map((b) => (
            <li key={b.label}>
              <span className="pm__breakdown-label">{b.label}</span>
              <span className="pm__breakdown-value">{b.value}</span>
            </li>
          ))}
        </ul>
      )}

      {data.offenders.length > 0 && (
        <ul className="widget-list">
          {data.offenders.map((o) => (
            <li key={o.car_id}>
              <button
                type="button"
                className="pm__row"
                onClick={() => navigate(`/admin/cars/${o.car_id}`)}
              >
                <span className="pm__car">
                  {o.car}
                  {o.plate ? <span className="plate">{o.plate}</span> : null}
                </span>
                <span className="pm__problems">{o.problems.join(' · ')}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
